import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 20000;
  overflow-x: visible;

  .inner {
    width: 100%;
  }

  .close {
    position: fixed;
    top: 26px;
    right: 20px;
    z-index: 30000;
    svg {
      stroke: var(--grey-0);
      fill: var(--grey-0);
    }
  }
  .anchor {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 1px;
    height: 1px;
  }

  .container {
    background: var(--simplified-sb-background);
    padding: 0px 16px;
    border-radius: 20px;
    box-shadow: var(--drop-shadow-15-25);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .story-bible-2-title {
    padding: 16px;
    padding-top: 24px;

    .story-bible-help-icon-container {
      position: absolute;
      width: 24px;
      height: 24px;
      top: 30px;
      right: 32px;
      svg {
        path {
          fill: var(--grey-2);
        }
      }
    }

    h1 {
      font-family: "GT Super Text";
      font-size: 28px;
      font-weight: 400;
      color: var(--grey-0);
    }

    p {
      color: var(--grey-2);
    }
  }

  .section {
    width: 100%;
  }
  .write {
    margin-top: -60px;
  }

  .scene {
    padding: 24px 24px 8px 24px;
    background: var(--menu-color);
    border-radius: 24px;
    width: 100%;
    box-shadow: var(--default-drop-shadow);
    position: relative;
    & > div {
      margin-bottom: 18px;
    }

    .legacy-summary-box,
    .summary-box {
      margin-top: 10px;
      color: var(--grey-0);
      font-style: italic;
      font-weight: 500;

      .note {
        margin-bottom: 18px;
      }
    }

    .summary-box {
      .show-hide-summary {
        font-weight: 500;
        font-style: underline;
        border-bottom: 1px solid;
        cursor: pointer;
      }
    }
  }

  h1 {
    max-width: none;
    text-align: left;
    margin-left: 0;
    margin-bottom: 0;
    color: var(--grey-0);
  }

  h1,
  h2,
  h3 {
    color: var(--grey-0);
    line-height: 1.5em;
  }

  h3 {
    margin-bottom: 1em;
  }

  .header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 20px;
    gap: 20px;
    justify-content: flex-end;
    h1 {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .right-side {
      display: flex;
      gap: 12px;
      position: sticky;
      right: 60px;
      margin-top: 8px;
      margin-bottom: 0px;
      z-index: 30000;

      button {
        margin-top: 0 !important;
        padding: 5px 15px !important;
        border-radius: 8px !important;
      }
      .select {
        width: 150px;
        position: relative;
        z-index: 30000;
      }
    }
    h1 {
      margin-bottom: 0 !important;
    }
  }

  .delete-cta {
    background: transparent !important;
    margin-top: 0px !important;
    margin-right: 12px;
    display: flex;
    align-items: center;
    padding: 4px 6px !important;
    border-radius: 8px !important;
    transition: background 200ms;
    position: relative;
    z-index: 30000;
    &:before {
      opacity: 0;
      transition: opacity 0.2s linear;
      transition-delay: 0.2s;
      position: absolute;
      content: "";
    }
    &:hover {
      background: var(--container-color) !important;
      &:before {
        content: "Delete this Chapter";
        text-transform: none;
        position: absolute;
        opacity: 1;
        left: 50%;
        transform: translate(-50%, 10px);
        line-height: 20px;
        height: 20px;
        font-weight: 500;
        top: 33px;
        padding: 3px 8px;
        background-color: var(--grey-0);
        color: var(--context-menu-text);
        border-radius: 6px;
        font-size: 12px;
        white-space: nowrap;
        z-index: 31000;
      }
    }
    svg {
      width: 22px;
      path {
        fill: var(--grey-1);
      }
    }
  }

  /*
   * TextareaAutosize applies weird scaling factors to the textarea when applying
   * this style. The only fix I was able to find is to not apply this style.
   * Ideally we'd like to migrate away from TextareaAutosize in favor of our own
   * Textarea but this is not easily possible here, yet.
  */
  textarea:not(.textarea-autosize) {
    color: var(--grey-0);
    background: var(--document-background);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 450px;
    font-size: 18px;
    padding: 1em;
    min-height: 310px;
    margin-bottom: 1em;
    line-height: 1.4em;
    font-family: "Inter";

    &.wide {
      width: 800px;
    }

    &.medium {
      min-height: 200px;
    }

    &.short {
      min-height: 120px;
    }
  }

  textarea.genre {
    height: 100px;
    min-height: 0;
  }

  .scenes {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 30px;
    position: relative;
    z-index: 10000;

    .header {
      /* height: 3px; */

      h3 {
        position: relative;
        top: 10px;
      }
    }
  }

  .draft-header {
    position: sticky;
    top: 0px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0px;
    background: var(--menu-color);
    z-index: 20000;
    .left-side {
      display: flex;
      align-items: center;
      .help {
        line-height: 24px;
        border-radius: 25px;
        height: 25px;
        width: 25px;
        position: relative;
        color: var(--grey-0);
        display: block;
        padding: 0;
        font-weight: bold;
        font-size: 17px;
        text-align: center;
        background: var(--menu-color-active);
        margin-left: 8px;
      }
    }
    h2 {
      font-weight: 500;
      font-size: 20px !important;
      margin-left: 12px;
      margin-bottom: 0px !important;
    }
  }

  .toast {
    position: fixed;
    bottom: 20px;
    right: 50%;
    background: var(--icon-button-fill);
    padding: 10px 15px;
    font-size: 18px;
    font-family: Inter;
    font-weight: 500;
    color: var(--text-highlight);
    border-radius: 5px;
    z-index: 100000000;
    transform: translate(50%, 0);
    animation: fade-in 0.5s ease forwards;
    opacity: 0;
  }

  .chapter-creator {
    margin-bottom: 20px;

    &.chapter-creator-top {
      margin-bottom: 40px;
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
